module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2-fm"
  }, [_c('a', {
    attrs: {
      "id": "authornote"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("AUTHOR’S NOTE")])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the summer of 2011, with relief and a renewed sense of appreciation, I returned with my family to our home on Mount Desert Island, just off the coast of Maine. I had just completed my service as the U.S. envoy for Middle East peace after two and a half difficult and disappointing years. Although I had for years summered on the island, it now seemed new and fresh and comforting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Going through familiar routines and attending events as I had in the past was also comforting. One such event was a meeting with Maine students at which I was asked to talk about my life. “You don’t have to prepare anything, just get up and talk from your heart,” I was told. That’s what I did. Without any notes or preparation of any kind, I told stories and answered questions about my life, mostly about growing up in Maine. The next morning I woke up early, sat at my desk, and wrote down some of those stories. Over the next few months I wrote some more. The result is this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is not a complete biography. It is rather a telling of some favorite stories about my very fortunate life. It’s also about the lessons I’ve learned along the way about negotiation, lessons that have been central to my ability to get things done in law, in business, in the Senate, and in Northern Ireland.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("After I retired from the U.S. Senate in 1995, I spent five years working on the peace process in Northern Ireland and did two tours of duty in the Middle East. These assignments, and others earlier in my life, took me to war-torn countries and exposed me to death and destruction on a scale that I had difficulty comprehending. The more ")]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("I experienced of life outside the United States and away from Maine, the more I appreciated and longed for both.")])]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In this book I mention only briefly two events that were an important part of my public life, the Iran-Contra investigation and the Northern Ireland peace process, because I have already written books about them. I also mention my work in the Middle East, but that deserves a full accounting in a separate book, which I hope to write in the near future. And although I describe some of the legislative efforts in which I engaged while in the Senate, they represent only a small part of my fifteen years of service there.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("I am fortunate to be an American, a citizen of what I believe to be, despite its many serious imperfections, the most open, the most free, the most just society in all of human history. In America no one should be guaranteed success, but everyone should have a fair chance to succeed. This is the story of how I came to have that chance.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Mount Desert Island")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("2014")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f422780","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/authornote.vue
// module id = 72
// module chunks = 0